 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React, {useMemo} from 'react'
import {useFragment} from 'react-relay'
import {MenuPosition} from '../hooks/useCoords'
import useMenu from '../hooks/useMenu'
import {FilterLabels} from '../types/constEnums'
import lazyPreload from '../utils/lazyPreload'

import DashSectionControls from './Dashboard/DashSectionControls'
import DashSectionHeader from './Dashboard/DashSectionHeader'
import DashFilterToggle from './DashFilterToggle/DashFilterToggle'
import {useQueryParameterParser} from '../utils/useQueryParameterParser'
import useAtmosphere from '../hooks/useAtmosphere'

const TeamFilterMenu = lazyPreload(
  () =>
    import(
      /* webpackChunkName: 'TeamFilterMenu' */
      './TeamFilterMenu'
    )
)





const MeetingsDashHeader = (props) => {
  const atmosphere = useAtmosphere()
  const {viewerId} = atmosphere
  const {viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment MeetingsDashHeader_viewer on User {
        id
        ...TeamFilterMenu_viewer
        teams {
          id
          name
        }
      }
    `,
    viewerRef
  )

  const {
    menuPortal: teamFilterMenuPortal,
    togglePortal: teamFilterTogglePortal,
    originRef: teamFilterOriginRef,
    menuProps: teamFilterMenuProps
  } = useMenu(MenuPosition.UPPER_LEFT, {
    isDropdown: true
  })
  const teams = _nullishCoalesce(_optionalChain([viewer, 'optionalAccess', _ => _.teams]), () => ( []))
  const {teamIds} = useQueryParameterParser(viewerId)
  const teamFilter = useMemo(
    () => (teamIds ? teams.find(({id: teamId}) => teamIds.includes(teamId)) : undefined),
    [teamIds, teams]
  )

  const teamFilterName = (teamFilter && teamFilter.name) || FilterLabels.ALL_TEAMS

  return (
    React.createElement(DashSectionHeader, null
      , React.createElement(DashSectionControls, { className: "w-full flex-wrap justify-start overflow-visible"   ,}
        , React.createElement(DashFilterToggle, {
          className: "mt-4 mr-16 mb-4 ml-0 sidebar-left:mt-0 sidebar-left:mr-24 sidebar-left:mb-0 sidebar-left:ml-0"       ,
          label: "Team",
          onClick: teamFilterTogglePortal,
          onMouseEnter: TeamFilterMenu.preload,
          ref: teamFilterOriginRef,
          value: teamFilterName,
          iconText: "group",
          dataCy: "team-filter",}
        )
        , teamFilterMenuPortal(React.createElement(TeamFilterMenu, { menuProps: teamFilterMenuProps, viewer: viewer,} ))
      )
    )
  )
}

export default MeetingsDashHeader
